export const getIntFromString = (price: string): number => {
  return Number.parseInt(price.replaceAll(/\s/g, '')) || 0
}

export function numberWithSpaces(x: number, withoutCents = false) {
  const regular = new RegExp(/\B(?=(\d{3})+(?!\d))/g)

  if (!withoutCents) {
    return Math.floor(x)
      .toString()
      .replaceAll(regular, ' ')
      .replace(/-?Infinity/, '0')
  }

  return x.toFixed(2).replaceAll(regular, ' ')
}

export const getPrice = (price: string | number) => {
  return numberWithSpaces(typeof price === 'string' ? getIntFromString(price) / 100 : price / 100) + ' ₽'
}

export const getCurrentUrl = () => {
  return window.location.href
}

/* Режим админа запускается только локально */
export const isAdmin = process.env.NEXT_PUBLIC_APP_TYPE === 'admin'

export const handleScrollToProducts = () => {
  window.scrollTo({
    behavior: 'smooth',
    top:
      window.scrollY +
      document.getElementById('products')!.getBoundingClientRect().top -
      document.getElementById('header')!.offsetHeight -
      16,
  })
}

export function pluralize(
  count: number,
  singularNominative: string,
  singularGenitive: string,
  pluralGenitive: string
): string {
  const modulo = Math.abs(count) % 100
  const remainder = modulo % 10

  if (modulo > 10 && modulo < 20) {
    return pluralGenitive
  }

  if (remainder > 1 && remainder < 5) {
    return singularGenitive
  }

  if (remainder === 1) {
    return singularNominative
  }

  return pluralGenitive
}

export const reverseWords = (text: string, splitter: string) => {
  const reversedText = text.split(splitter).reverse().join(',')

  return reversedText
}
